export default api => ({
  payCorpo: async (engineId = 5, params) =>
    await api.post(`/checkoutcorpo/${engineId}/pay`, {
      ...params
    })
});
